import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import useDataContext from "../../providers/DataProvider/useDataContext";
import { subscribeToScroll } from "../../assets/scripts/ScrollManager";
import Navbar from "../Navbar/Navbar";
import LanguageButton from "../LanguageButton/LanguageButton";
import { MenuBarIcon, CloseIcon } from "../Icons/Icons";
import "./Header.css";


interface Props {
    isHomePage?: boolean
    onMenuToggle?: (isOpen: boolean) => void
}

const Header: React.FC<Props> = ({ isHomePage, onMenuToggle }) => {
    const { data } = useDataContext();
    const [isScrolled, setIsScrolled] = useState(!isHomePage);
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    useEffect(() => {
        if (isHomePage) {
            /* Pequeña condición por si se actualiza la página por la mitad */
            if (window.scrollY > 0 && !isScrolled) {
                setIsScrolled(true);
            }

            const unsuscribe = subscribeToScroll(setIsScrolled);
            return () => {
                unsuscribe();
            } 
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handleToggleMenu = () => {
        const newState = !isMenuOpen
        setIsMenuOpen(newState);
        onMenuToggle?.(newState);
    }

    return (
        <header className={`${ isHomePage ? "fixed top-0 z-50 pt-8" : "sticky top-0 z-50"} w-full 
                            transition-all duration-500 ease-in-out
                            ${ isScrolled ? "isScrolled" : "bg-transparent" }`}>
            {/* Desktop Navbar */}
            <div className={`container mx-auto px-4 py-4 flex justify-between items-center`}>
                <Link to={data.components.header.mainLogo.link}>
                    <img src={data.components.header.mainLogo.image.src} 
                         alt={data.components.header.mainLogo.image.alt}
                         className={`w-28 lg:w-32 transition-opacity duration-300 ease-out
                                  ${ isScrolled ? "opacity-100" : `${ isMenuOpen && isHomePage ? "opacity-100" : "opacity-0 lg:opacity-100"}`}`}/>
                </Link>

                <div className="hidden lg:flex">
                    <Navbar ariaLabel="desktop-header-nav"
                            className="hidden lg:flex lg:gap-8 lg:text-lg text-fifth-solid"
                            isHomePage={isHomePage}
                            isHeader/>

                </div>

                <div className="hidden lg:flex lg:justify-center lg:items-center lg:w-32">
                    <LanguageButton ariaLabel="desktop-language-change-button"
                                    buttonClassName="hidden lg:inline-block text-fifth-solid"/>
                </div>

                <button aria-label="menu-bar-button" 
                        className="inline-block lg:hidden"
                        onClick={handleToggleMenu}>
                {
                    isMenuOpen ? (
                        <CloseIcon className="text-fifth-solid size-10"/>
                    ) : (
                        <MenuBarIcon className="text-fifth-solid size-10"/>
                    )
                }
                    
                </button>
            </div>

            {/* Mobile Navbar */}
            <div className={`fixed z-10 w-full px-4 pb-4 lg:hidden
                             transition duration-500 ease-out
                          ${ isScrolled ? "bg-second-solid" : ""}
                          ${ isMenuOpen ? "opacity-100" : "translate-x-full opacity-0"}`}>
                <Navbar ariaLabel="mobile-header-nav"
                        className="flex flex-col items-center gap-2 text-lg text-fifth-solid
                                   lg:hidden"
                        isHomePage={isHomePage}
                        isHeader/>

                <LanguageButton ariaLabel="mobile-language-change-button"
                                buttonClassName="text-fifth-solid inline-block lg:hidden"
                                isHomePage={isHomePage}
                                isMenuOpen={isMenuOpen}/>
            </div>
        </header>
    );
}

export default Header;
